import React, { useState } from "react";
import SideModal from "../../general/Sidemodal";
import { DonationDetailForm } from "../donationdetails/DonationDetailForm";

interface Donation {
    url: string;
    Donations: any[];
     onSuccess?: () => void;
}

export const DonationAssigned = ({ url, Donations }: Donation,  onSuccess,) => {
    const [editmodal, seteditmodal] = useState(false);
    const [editingId, setEditingId] = useState<string | null>(null);

  const handleEditClick = (id: string) => {
    setEditingId(id);
    seteditmodal(true)
  }; 
  
    return (
        <div>
            {Donations.length === 0 ? (
                <div className="text-center py-4 text-gray-500 text-lg">
                    Donations or Balance Transfer Not Assigned
                </div>
            ) : (
                <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                    <thead className="bg-gray-50 dark:bg-gray-800">
                        <tr>
                            <th scope="col" className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500">
                                <span>Actions</span>
                            </th>
                            <th scope="col" className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500">
                                <span>Name</span>
                            </th>
                            <th scope="col" className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500">
                                <span>Donation Purpose</span>
                            </th>
                            <th scope="col" className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500">
                                <span>Donation Type</span>
                            </th>
                            <th scope="col" className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500">
                                <span>Amount</span>
                            </th>
                            <th scope="col" className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500">
                                DonatedOn
                            </th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200 dark:divide-gray-700 dark:bg-gray-900">
                        {Donations.map((donation: any, index: number) => (
                            <tr className="bg-[#ffff] text-gray-500" key={index}>
                                <td className="px-4 py-4 text-sm whitespace-nowrap">
                                    <div className="flex items-center gap-x-6">
                                        <button

                                            onClick={() => handleEditClick(donation.id)}

                                            className="text-gray-500 transition-colors duration-200 dark:hover:text-yellow-500 dark:text-gray-300 hover:text-yellow-500 focus:outline-none"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke-width="1.5"
                                                stroke="currentColor"
                                                className="w-5 h-5"
                                            >
                                                <path
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                                                />
                                            </svg>
                                        </button>
                                    </div>
                                </td>
                                <td className="px-4 py-4 text-sm font-medium text-gray-500">
                                    {donation.userName}
                                </td>
                                <td className="px-4 py-4 text-sm font-medium text-gray-500">
                                    {donation.donationDetails?.[0]?.donationPurpose ?? "-"}
                                </td>
                                <td className="px-4 py-4 text-sm font-medium text-gray-500">
                                    {donation.donationDetails?.[0]?.donationType ?? "-"}
                                </td>

                                <td className="px-4 py-4 text-sm text-gray-500">
                                    {donation.amount}
                                </td>
                                <td className="px-4 py-4 text-sm text-gray-500">
                                    {new Date(donation.donatedOn).toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric",
                                    })}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
            <SideModal isOpen={editmodal} onClose={() => seteditmodal(false)}>
                <DonationDetailForm
                    url={url}
                    setAdd={seteditmodal}
                    Id={editingId}
                    onSuccess={() => onSuccess}
                />
            </SideModal>
        </div>
    );
};
